<div class="photo-input">
  <input
    tabindex="999"
    #fileInput
    autocomplete="off"
    type="file"
    name="photo"
    id="photo-propriete"
    accept="image/*"
    (change)="onImageChange($event)"
  />
</div>

<div class="photo-editor-container" [ngClass]="{ hidden: !isVisible }" [cdkTrapFocus]="isVisible">
  <button class="close-button" (click)="close()" id="close-button" [attr.aria-label]="'btn.fermer' | translate">
    <img src="{{ 'assets/images/icone-close-white.svg' | cheminAbsoluStatique }}" alt="" />
  </button>

  <div class="photo-editor">
    <div class="preview-wrapper" [ngClass]="{ hidden: !hasPhoto }">
      <div id="photo-preview" class="photo-preview"></div>
    </div>

    <div class="actions" *ngIf="hasPhoto">
      <div class="rotate-butons">
        <button
          class="flat-btn"
          (click)="rotateRight()"
          id="rotate-button"
          [attr.aria-label]="'propriete.photo.rotation-photo' | translate"
        >
          <img src="{{ 'assets/images/rotate.svg' | cheminAbsoluStatique }}" alt="" />
        </button>
      </div>

      <button class="flat-btn btn-yellow" (click)="save()" id="save-button" [disabled]="isProcessing">
        {{ 'propriete.photo.terminer' | translate }}
      </button>
    </div>
  </div>
</div>
